<div class="p-6">
  <div class="flex items-start gap-4">
    <!-- Icon based on type -->
    <div class="flex-shrink-0 mt-1">
      <i
        class="pi"
        [class]="getIconClass()"
        [class.pi-check-circle]="data.type === 'success'"
        [class.pi-exclamation-triangle]="data.type === 'warning'"
        [class.pi-times-circle]="data.type === 'error'"
        [class.pi-info-circle]="data.type === 'info' || !data.type">
      </i>
    </div>

    <div class="flex-1">
      <!-- whitespace-pre-line: callers may separate statements with newlines. -->
      <p class="text-bb-text-secondary leading-relaxed whitespace-pre-line">{{ data.message }}</p>
    </div>
  </div>

  <div class="flex justify-end gap-2 mt-6 pt-4 border-t border-bb-border">
    <app-button
      type="button"
      variant="ghost"
      (clicked)="onCancel()">
      {{ data.cancelText || 'Cancel' }}
    </app-button>
    <app-button
      type="button"
      [variant]="getButtonVariant()"
      (clicked)="onConfirm()"
      autofocus>
      {{ data.confirmText || 'OK' }}
    </app-button>
  </div>
</div>
